import type { InventoryLevel, UntrackedMaterial } from '../interfaces/ILogistics.js';

/** Derived on the page from the data it already loads, like the alerts tile,
 *  which reads the live rows rather than a stored figure. */

export type KpiTone = 'good' | 'warn' | 'urgent';

/** Zero green, one to four amber, five and up red (ruling 2026-09-24). */
export function unsyncedTone(count: number): KpiTone {
  if (count === 0) return 'good';
  return count < 5 ? 'warn' : 'urgent';
}

/** Materials with an arrival nobody has reconciled into stock: tracked rows
 *  awaiting renewal, then untracked materials whose order landed and was
 *  never synced — in row order, so the tile reads like the panels below. */
export function unsyncedMaterials(inventory: InventoryLevel[], untracked: UntrackedMaterial[]): string[] {
  return [
    ...inventory.filter((l) => l.awaitingRenewal).map((l) => l.materialName),
    ...untracked.filter((m) => m.deliveredAt !== null && !m.isSynced).map((m) => m.materialName),
  ];
}
